import API from '@/api'
import UserAccessDataResponse from './models/UserAccessDataResponse'
const getUserAccessData = async (): Promise<UserAccessDataResponse> => {
  return await API.UserAccessDataRepository.getUserAccessData()
}

export default getUserAccessData
